import axios from "axios";
import { BASE_URL } from "./api";


export async function getDelegations(token, queryParams = "") {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-submission-delegates/${queryParams}`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function createDelegation(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-submission-delegates/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: payload,
    }).then((r) => r.data);
}


export async function deactivateDelegation(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-submission-delegates/${id}/deactivate/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function getMyDelegators(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-submission-delegates/my-delegators/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}
